import { useState, useEffect } from "react";

const ThemeSwitcher = () => {
  const themeStorageKey = "tablerTheme";
  const defaultTheme = "light";
  
  // Lee el tema guardado en localStorage, o usa el tema predeterminado
  const storedTheme = localStorage.getItem(themeStorageKey);
  const initialTheme = storedTheme ? storedTheme : defaultTheme;

  const [theme, setTheme] = useState(initialTheme);

  // Cambiar el tema cuando se seleccione uno nuevo
  const switchTheme = (newTheme) => {
    setTheme(newTheme);
    localStorage.setItem(themeStorageKey, newTheme);
  };

  // Aplicar el tema en el body
  useEffect(() => {
    if (theme === "dark") {
      document.body.setAttribute("data-bs-theme", "dark");
    } else {
      document.body.removeAttribute("data-bs-theme");
    }
  }, [theme]);

  return (
    <div className="card mt-2 text-center">
      <div className="card-body">
        <nav className="nav nav-segmented nav-1" role="tablist">
          <button
            className={`nav-link ${theme === "light" ? "active" : ""}`}
            role="tab"
            aria-selected={theme === "light"}
            onClick={() => switchTheme("light")}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon nav-link-icon icon-2">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
              <path d="M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7" />
            </svg>
          </button>
          <button
            className={`nav-link ${theme === "dark" ? "active" : ""}`}
            role="tab"
            aria-selected={theme === "dark"}
            onClick={() => switchTheme("dark")}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon nav-link-icon icon-2">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z" />
            </svg>
          </button>
        </nav>
      </div>
    </div>
  );
};

export default ThemeSwitcher;
